<template>
  <div>
    <h1 v-bg-typography="'h1'" :style="{ marginTop: '10px' }">
      Dynamic analysis
    </h1>
    <div class="message" v-if="!this.testData">
      <bg-icon name="alertCircle"></bg-icon>
      <div class="content">
        Go to Scenes to generate the heatmap video and emotion scores.
      </div>
      <bg-button
        @click="$router.push(`/research/test/${$route.params.id}/scenes`)"
        text="To Scenes"
      ></bg-button>
    </div>
    <div class="container" v-if="testData !== null">
      <bg-section-video
        :data="testData"
        :customControls="false"
      ></bg-section-video>
    </div>
  </div>
</template>

<style lang="scss" scoped>
$green: var(--bg-color-green);
$pink: var(--bg-color-pink);
$yellow: var(--bg-color-yellow);
.legend {
  flex-direction: row-reverse;
  padding-bottom: 20px;
}

.chart-container {
  width: 100%;
  height: 160px;
  position: relative;
  margin-top: 15px;
}

.emotion-chart {
  margin-bottom: 25px;
}

.container {
  max-width: 800px;
  width: 100%;
}

.video-container {
  position: relative;
}
</style>

<script>
import moment from "moment";
import BgSectionVideo from "@/components/bg-section-video";
import BgTypography from "@/directives/bg-typography";
import BasePageTitle from "@/components/base-page-title";
import API from "@/api";
import { mapState } from "vuex";
import BgIcon from "@/components/bg-icon";
import BgButton from "@/components/bg-button";
export default {
  name: "overview",
  components: {
    BgSectionVideo,
    BasePageTitle,
    BgIcon,
    BgButton,
  },
  directives: {
    BgTypography,
  },
  data() {
    return {
      testData: null,
      videoRef: null,
      totalTime: 0,
      currentTime: 0,
      newScrubberTime: 0,
      scrubberKey: 2,
    };
  },
  computed: {
    ...mapState({
      testState: (state) => state.test,
    }),
  },
  watch: {
    "$route.params.id": function() {
      this.fetchData();
    },
  },
  methods: {
    fetchData() {
      const processed = this.testState.participants.find(
        (p) => p.type === "video_heatmap"
      );
      const testId = this.$route.params.id;
      if (processed && testId) {
        API.test.getVideoParticipant(this.$route.params.id).then((res) => {
          this.testData = {
            ...res,
          };
        });
      }
    },
    setVideoRef(ref) {
      this.videoRef = ref;
    },
    timeUpdate(time) {
      this.currentTime = time;
    },
    setNewTime(newTimePercentage) {
      this.newScrubberTime = this.videoRef.duration * newTimePercentage;
    },
    handleVideoLoad(video) {
      if (video) {
        if (this.$route.query.timestamp) {
          const startTime = moment(this.data.started_at);
          const endTime = moment(this.data.ended_at);
          const startPos = moment(Number(this.$route.query.timestamp));
          const videoLength = endTime.diff(startTime, "seconds");
          3;
          const timeElapsed = startPos.diff(startTime, "seconds");
          this.setNewTime(timeElapsed / videoLength);
        }
        this.totalTime = video.duration;
      }
    },
  },
  created() {
    this.fetchData();
  },
};
</script>
